export type BannerLayoutMode = 'boxed' | 'full';
export type BannerHeightSize = 'standard' | 'large';

export interface BannerSettingsEntityProps {
  layout: BannerLayoutMode;
  size: BannerHeightSize;
  autoplaySpeed: number;
}

export class BannerSettingsEntity {
  public layout: BannerLayoutMode;
  public size: BannerHeightSize;
  public autoplaySpeed: number;

  constructor(props?: Partial<BannerSettingsEntityProps>) {
    this.layout = props?.layout === 'full' ? 'full' : 'boxed';
    this.size = props?.size === 'large' ? 'large' : 'standard';
    this.autoplaySpeed = props?.autoplaySpeed && props.autoplaySpeed >= 1000 ? props.autoplaySpeed : 6500;
  }
}
